import type { TimelineItem } from '@/types/timeline'

// Timeline data for Steve Jobs (unsorted)
const rawTimelineData: TimelineItem[] = [
  {
    id: 1,
    year: 1955,
    title: 'Birth and Adoption',
    description:
      'On February 24, 1955, Steve Jobs was born in San Francisco and later adopted by Paul and Clara Jobs, who promised his biological mother they would send him to college.',
    image: '/images/steve/jobs-young.jpg',
  },
  {
    id: 2,
    year: 1967,
    title: 'Failed Attempt at Joining HP at Age 12',
    description:
      "Cold-calling HP's Bill Hewlett; illustrative of his bold entrepreneurial character early in life.",
    image: '/images/steve/jobs-hp-call.jpg',
  },
  {
    id: 3,
    year: 1969,
    title: 'Admiration for Bob Dylan & The Beatles',
    description:
      "During his late teens, Jobs developed a deep admiration for Bob Dylan and The Beatles, musical influences that inspired Apple's creative identity and Jobs' expressive presentation style throughout his life.",
    image: '/images/steve/jobs-music-influences.jpg',
  },
  {
    id: 4,
    year: 1971,
    title: 'Meeting Steve Wozniak',
    description:
      'In 1971, Jobs met Steve Wozniak through mutual friend Bill Fernandez, beginning the foundational friendship and partnership that would later create Apple Computer.',
    image: '/images/steve/jobs-wozniak-meeting.jpg',
  },
  {
    id: 5,
    year: 1972,
    title: 'Blue Boxes Demonstration at Berkeley',
    description:
      'Jobs and Wozniak demonstrating Blue Boxes at Berkeley - early entrepreneurship and collaboration; a formative rebellious and technical experience.',
    image: '/images/steve/blue-boxes-berkeley.jpg',
  },
  {
    id: 6,
    year: 1973,
    title: 'Dropping Out of Reed College',
    description:
      'In fall 1973, Jobs dropped out of Reed College but continued to audit classes, including a calligraphy course that would later inspire his emphasis on typography and fonts in the Macintosh.',
    image: '/images/steve/jobs-reed-college.jpg',
  },
  {
    id: 7,
    year: 1973,
    title: 'Zen Buddhism Studies',
    description:
      'In 1973-74, Jobs began studying Zen Buddhism and practicing meditation, philosophical pursuits that shaped his later approach to simplicity, mindfulness, and design minimalism at Apple.',
    image: '/images/steve/jobs-zen-buddhism.jpg',
  },
  {
    id: 8,
    year: 1974,
    title: 'Travels to India',
    description:
      'In 1974, Jobs traveled to India seeking spiritual enlightenment, an experience that profoundly influenced his philosophy, aesthetic sensibilities, and approach to life and business.',
    image: '/images/steve/jobs-india-trip.jpg',
  },
  {
    id: 9,
    year: 1975,
    title: 'Working at Atari on Breakout',
    description:
      "In 1975-76, Jobs worked at Atari where he was tasked with designing the 'Breakout' game circuit. He famously involved Wozniak but paid him only a portion of Atari's bonus, a controversial moment in their early partnership.",
    image: '/images/steve/jobs-atari-breakout.jpg',
  },
  {
    id: 10,
    year: 1976,
    title: 'Founding of Apple',
    description:
      "On April 1, 1976, Steve Jobs, Steve Wozniak, and Ronald Wayne founded Apple Computer Company, beginning in Jobs' parents' garage in Los Altos, California.",
    image: '/images/steve/apple-founding.jpg',
  },
  {
    id: 11,
    year: 1976,
    title: 'Launch of Apple I',
    description:
      'In July 1976, Apple released the Apple I, a hand-built circuit board created by Steve Wozniak. It was sold as a DIY kit that users needed to add a keyboard and display to use.',
    image: '/images/steve/apple-i.jpg',
  },
  {
    id: 12,
    year: 1976,
    title: 'Establishing First Headquarters',
    description:
      "In 1976-77, Apple moved from Jobs' garage to its first official office space on Stevens Creek Boulevard in Cupertino, marking the company's first step toward becoming a legitimate business.",
    image: '/images/steve/first-apple-office.jpg',
  },
  {
    id: 13,
    year: 1977,
    title: 'Introduction of the Apple II',
    description:
      'On April 16, 1977, Apple introduced the Apple II at the West Coast Computer Faire, the first mass-market personal computer and a significant commercial success that established Apple in the industry.',
    image: '/images/steve/apple-ii-introduction.jpg',
  },
  {
    id: 14,
    year: 1978,
    title: 'Recruiting Mike Markkula',
    description:
      'In 1978, Jobs recruited Mike Markkula as an investor and CEO mentor, who proved instrumental in early Apple strategy and provided pivotal business guidance to the young company.',
    image: '/images/steve/jobs-markkula.jpg',
  },
  {
    id: 15,
    year: 1978,
    title: 'Steve Jobs Denied Paternity of Lisa Brennan-Jobs',
    description:
      "Significant personal controversy during 1978-79; later influenced naming of Apple's 'Lisa' computer.",
    image: '/images/steve/jobs-lisa-paternity.jpg',
  },
  {
    id: 16,
    year: 1979,
    title: 'Xerox PARC Visit',
    description:
      'In December 1979, Jobs visited Xerox PARC where he saw the graphical user interface that would inspire the Lisa and Macintosh computers, changing the course of computing history.',
    image: '/images/steve/xerox-parc-visit.jpg',
  },
  {
    id: 17,
    year: 1980,
    title: 'Introduction of the Apple III',
    description:
      "On May 19, 1980, Apple introduced the Apple III, the company's first major commercial failure, which provided important lessons about design, testing, and market positioning.",
    image: '/images/steve/apple-iii-launch.jpg',
  },
  {
    id: 18,
    year: 1980,
    title: 'Apple IPO',
    description:
      'On December 12, 1980, Apple went public with its initial public offering, generating more capital than any IPO since Ford in 1956 and instantly making Jobs a multimillionaire.',
    image: '/images/steve/apple-ipo.jpg',
  },
  {
    id: 19,
    year: 1982,
    title: 'Time Magazine Cover',
    description:
      'On February 15, 1982, Jobs appeared on the cover of Time Magazine, recognizing him as a leader in the personal computing revolution at just 27 years old.',
    image: '/images/steve/jobs-time-cover.jpg',
  },
  {
    id: 20,
    year: 1982,
    title: 'Signing the Inside of Original Macintosh Case',
    description:
      "In 1982-83, Jobs insisted the design team's signatures be included inside each Macintosh, emphasizing the personal craft and pride behind Apple products.",
    image: '/images/steve/macintosh-signatures.jpg',
  },
  {
    id: 21,
    year: 1983,
    title: 'International Design Conference in Aspen',
    description:
      'In June 1983, Jobs presented his visionary ideas for computing at the International Design Conference in Aspen, predicting portable devices, wireless networking, and app stores decades before they became reality.',
    videoUrl: 'https://youtu.be/yHB_5WmRbho?si=aj33jrlZBfLyPqD-',
  },
  {
    id: 22,
    year: 1983,
    title: "Making of '1984' Super Bowl Commercial",
    description:
      "Behind-the-scenes footage of Ridley Scott directing the iconic Super Bowl ad with 200 skinheads as extras, filmed in London for Apple's Macintosh launch.",
    videoUrl: 'https://www.youtube.com/watch?v=owf5b2U9AXs',
  },
  {
    id: 23,
    year: 1983,
    title: 'Launch of Lisa Computer',
    description:
      'First commercial computer with a graphical user interface; commercially failed but historically significant for Apple and Jobs.',
    image: '/images/steve/lisa-computer-launch.jpg',
  },
  {
    id: 24,
    year: 1983,
    title: 'Recruits John Sculley',
    description:
      "On April 8, 1983, Jobs recruited PepsiCo executive John Sculley to become Apple's CEO with the famous line: 'Do you want to sell sugar water for the rest of your life, or come with me and change the world?'",
    image: '/images/steve/jobs-sculley.jpg',
  },
  {
    id: 25,
    year: 1983,
    title: 'Steve Jobs Points at IBM in Manhattan',
    description:
      "In December 1983, just weeks before the Macintosh launch, Jobs was photographed spontaneously pointing at an IBM logo while walking around Manhattan during a trip to meet with Newsweek about a potential Mac cover story. This candid moment captures his defiant attitude toward Apple's biggest competitor.",
    image: '/images/steve/jobs-ibm-manhattan.jpg',
  },
  {
    id: 26,
    year: 1984,
    title: "'1984' Super Bowl Commercial Airs",
    description:
      'On January 22, 1984, the legendary Ridley Scott-directed commercial aired during Super Bowl XVIII, introducing the Macintosh and changing advertising forever.',
    videoUrl: 'https://www.youtube.com/watch?v=ErwS24cBZPc',
  },
  {
    id: 27,
    year: 1984,
    title: 'Launch of the Original Macintosh',
    description:
      "On January 24, 1984, Jobs introduced the original Macintosh, the first mass-market computer with a graphical user interface, following the famous '1984' Super Bowl advertisement.",
    videoUrl: 'https://www.youtube.com/watch?v=1tQ5XwvjPmA',
  },
  {
    id: 28,
    year: 1984,
    title: "Iconic 'Hello' Macintosh Demonstration",
    description:
      "On January 24, 1984, during the Macintosh launch, Jobs showcased the computer's capabilities as it 'introduced itself' by speaking 'Hello' to an astonished audience.",
    videoUrl: 'https://www.youtube.com/watch?v=1tQ5XwvjPmA',
  },
  {
    id: 29,
    year: 1984,
    title: "1984 Shareholders Meeting and 'Pirates vs. Navy' Episode",
    description:
      "Jobs famously divided Apple's Macintosh and Lisa teams, fueling internal rivalry—an iconic leadership style moment.",
    image: '/images/steve/pirates-navy.jpg',
  },
  {
    id: 30,
    year: 1985,
    title: 'Departure from Apple',
    description:
      "On September 17, 1985, Jobs was forced out of Apple after a power struggle with the board and CEO John Sculley, marking the beginning of his 'wilderness years.'",
    image: '/images/steve/jobs-departure-apple.jpg',
  },
  {
    id: 31,
    year: 1985,
    title: 'Founding NeXT Inc.',
    description:
      'In 1985, after leaving Apple, Jobs founded NeXT Inc. to create high-end computers for the education and business markets, continuing his vision for computing innovation.',
    image: '/images/steve/next-founding.jpg',
  },
  {
    id: 32,
    year: 1985,
    title: 'Sells All But One Share of Apple',
    description:
      'In 1985, following his departure, Jobs sold all but one share of his Apple stock, symbolizing his emotional break with the company he co-founded.',
    image: '/images/steve/jobs-selling-shares.jpg',
  },
  {
    id: 33,
    year: 1986,
    title: 'Purchase of Graphics Group (Pixar)',
    description:
      'On February 3, 1986, Jobs purchased the Graphics Group from Lucasfilm for $10 million, which was later renamed Pixar. This marked a critical pivot from hardware/software to animation.',
    image: '/images/steve/pixar-purchase.jpg',
  },
  {
    id: 34,
    year: 1986,
    title: 'Discovery of Biological Sister Mona Simpson',
    description:
      'In 1986, Jobs discovered and reunited with his biological sister, novelist Mona Simpson, during his search for his birth parents, forming a strong lifelong bond.',
    image: '/images/steve/jobs-mona-simpson.jpg',
  },
  {
    id: 35,
    year: 1987,
    title: 'Paul Rand Designs NeXT Logo',
    description:
      "In 1987, Steve Jobs commissioned legendary graphic designer Paul Rand to create the NeXT logo for $100,000. Rand delivered the logo in the form of a 100-page book explaining his design rationale and process. The iconic tilted cube logo became central to Jobs' vision for NeXT's brand identity, demonstrating his obsession with design excellence even during his time away from Apple.",
    image: '/images/steve/paul-rand-next-logo.jpg',
  },
  {
    id: 36,
    year: 1988,
    title: 'NeXT Computer Launch at Davies Symphony Hall',
    description:
      'On October 12, 1988, Jobs unveiled the NeXT Computer in a lavish multimedia extravaganza at Davies Symphony Hall, featuring a duet between the computer and a violinist.',
    videoUrl: 'https://www.youtube.com/watch?v=Zs3NwqW4d48',
  },
  {
    id: 37,
    year: 1988,
    title: 'The NeXT Day Follow-up Event',
    description:
      'On October 13, 1988, selected educators and software developers attended the first public technical overview of the NeXT Computer.',
    image: '/images/steve/next-day-event.jpg',
  },
  {
    id: 38,
    year: 1989,
    title: 'NeXT Computer Launches NeXTstation',
    description:
      'On September 18, 1989, NeXT launched the NeXTstation, an influential workstation later used by Tim Berners-Lee to develop the World Wide Web.',
    videoUrl: 'https://www.youtube.com/watch?v=d76GBkG3oyM',
  },
  {
    id: 39,
    year: 1989,
    title: "Pixar's 'Tin Toy' Wins Oscar",
    description:
      "On March 29, 1989, Pixar's short film 'Tin Toy' won the Academy Award for Best Animated Short Film, the first computer-generated work to receive this honor.",
    videoUrl: 'https://www.youtube.com/watch?v=DWi2WTqD59A',
  },
  {
    id: 40,
    year: 1991,
    title: 'Marriage to Laurene Powell',
    description:
      'On March 18, 1991, Jobs married Laurene Powell in a private ceremony, marking an important personal milestone during his time away from Apple.',
    image: '/images/steve/jobs-laurene-wedding.jpg',
  },
  {
    id: 41,
    year: 1995,
    title: "Release of Pixar's Toy Story",
    description:
      "On November 22, 1995, Pixar released 'Toy Story,' the first entirely computer-animated feature film, establishing Pixar as an animation powerhouse under Jobs' leadership.",
    videoUrl: 'https://www.youtube.com/watch?v=oRHpyXrebIY',
  },
  {
    id: 42,
    year: 1995,
    title: 'The Lost Interview',
    description:
      "In 1995, Jobs gave a candid interview later known as 'The Lost Interview,' where he reflected on his departure from Apple, innovation, and corporate culture. It was rediscovered and released in 2011.",
    videoUrl: 'https://www.youtube.com/watch?v=9m68auPIPRk',
  },
  {
    id: 43,
    year: 1996,
    title: 'Apple Acquires NeXT',
    description:
      'On December 20, 1996, Apple acquired NeXT for $429 million, bringing Jobs back to Apple and providing the foundation for what would become modern macOS.',
    image: '/images/steve/apple-next-acquisition.jpg',
  },
  {
    id: 44,
    year: 1997,
    title: 'Apple Town Hall Meeting after Return to Apple',
    description:
      "Private keynote to Apple employees after NeXT acquisition; emotional turning point in Apple's history with Jobs rallying the company.",
    videoUrl: 'https://www.youtube.com/watch?v=8-Fs0pD2Hsk',
  },
  {
    id: 45,
    year: 1997,
    title: 'Microsoft Investment Announcement',
    description:
      'On August 6, 1997, at Macworld Boston, Jobs announced a controversial $150 million investment from Microsoft, helping stabilize Apple financially during a critical period.',
    videoUrl: 'https://www.youtube.com/watch?v=WxOp5mBY9IY',
  },
  {
    id: 46,
    year: 1997,
    title: 'Think Different Campaign',
    description:
      "On August 8, 1997, Apple launched the iconic 'Think Different' advertising campaign celebrating creativity and innovation, marking the beginning of Apple's brand renaissance.",
    videoUrl: 'https://www.youtube.com/watch?v=GEPhLqwKo6g',
  },
  {
    id: 47,
    year: 1997,
    title: 'Return as Interim CEO',
    description:
      "On September 16, 1997, Jobs returned as interim CEO (iCEO) of Apple, marking a critical turning point in the company's history and the beginning of its legendary comeback.",
    image: '/images/steve/jobs-return-apple.jpg',
  },
  {
    id: 48,
    year: 1997,
    title: "Jobs' Return to Macworld Expo Keynote",
    description: 'Emotional keynote return, rallying support to revive Apple.',
    videoUrl: 'https://www.youtube.com/watch?v=IOs6hnTI4lw',
  },
  {
    id: 49,
    year: 1998,
    title: 'Steve Jobs & Bill Gates Joint Appearance',
    description:
      'On January 6, 1998, at Macworld Boston, Jobs and Gates appeared together on stage, symbolizing a truce and collaboration between Apple and Microsoft after years of rivalry.',
    image: '/images/steve/microsoft-investment.jpg',
  },
  {
    id: 50,
    year: 1998,
    title: 'Introduction of the iMac G3',
    description:
      "On May 6, 1998, Jobs unveiled the colorful, all-in-one iMac G3, a bold design move that signaled Apple's comeback under his leadership and redefined computer aesthetics.",
    videoUrl: 'https://www.youtube.com/watch?v=BiWd8ujtK5k',
  },
  {
    id: 51,
    year: 1998,
    title: 'Trademark Black Turtleneck Look',
    description:
      "Around 1998-99, Jobs established his iconic black turtleneck, jeans, and sneakers uniform. This minimalist look became synonymous with his personal brand during Apple's revival period.",
    image: '/images/steve/jobs-black-turtleneck.jpg',
  },
  {
    id: 52,
    year: 1999,
    title: 'Introduction of iBook with Wi-Fi',
    description:
      "On July 21, 1999, Jobs demonstrated wireless internet with the famous 'Hula Hoop' demo, showcasing the iBook's wireless capabilities by browsing the web while walking through a hoop, proving no wires were attached.",
    image: '/images/steve/ibook-wifi-demo.jpg',
  },
  {
    id: 53,
    year: 2000,
    title: 'Jobs Officially Becomes Apple CEO',
    description:
      "On January 5, 2000, Jobs officially dropped the 'interim' from his title and became permanent CEO of Apple, fully committing to leading the company he co-founded.",
    videoUrl: 'https://www.youtube.com/watch?v=JgHtKFuY3bE',
  },
  {
    id: 54,
    year: 2001,
    title: 'First Apple Retail Store Opens',
    description:
      "On May 19, 2001, the first Apple Retail Stores opened in Tysons Corner, Virginia, and Glendale, California, launching Apple's revolutionary retail strategy against industry skepticism.",
    videoUrl: 'https://www.youtube.com/watch?v=OJtQeMHGrgc',
  },
  {
    id: 55,
    year: 2001,
    title: 'Original iPod Launch',
    description:
      "On October 23, 2001, Jobs introduced the original iPod with the promise of '1,000 songs in your pocket,' beginning Apple's expansion beyond computers and changing the music industry forever.",
    videoUrl: 'https://www.youtube.com/watch?v=Mc_FiHTITHE',
  },
  {
    id: 56,
    year: 2001,
    title: 'Mercedes SL55 AMG with No License Plate',
    description:
      'In the early 2000s, Jobs became known for driving a silver Mercedes SL55 AMG with no license plate, reflecting his rebellious personality and penchant for challenging norms.',
    image: '/images/steve/jobs-mercedes.jpg',
  },
  {
    id: 57,
    year: 2002,
    title: "'Switch' Campaign Launch",
    description:
      "On June 10, 2002, Apple launched its major 'Switch' advertising campaign featuring real people who had switched from PCs to Macs, marking Apple's largest ad campaign since 'Think Different.'",
    videoUrl: 'https://www.youtube.com/watch?v=VHid1bcf1sM',
  },
  {
    id: 58,
    year: 2003,
    title: 'iTunes Music Store Launch',
    description:
      'On April 28, 2003, Jobs launched the iTunes Music Store, revolutionizing digital music distribution and creating a legal alternative to music piracy that would transform the entire music industry.',
    videoUrl: 'https://www.youtube.com/watch?v=NF9o46zK5Jo',
  },
  {
    id: 59,
    year: 2004,
    title: "Jobs' Cancer Diagnosis",
    description:
      'On August 1, 2004, Jobs publicly announced his pancreatic cancer diagnosis, revealing his health struggles and vulnerability while continuing to lead Apple through a period of tremendous innovation.',
    image: '/images/steve/jobs-health-announcement.jpg',
  },
  {
    id: 60,
    year: 2005,
    title: 'Stanford Commencement Speech',
    description:
      "On June 12, 2005, Jobs delivered his famous Stanford commencement address, concluding with the inspirational quote: 'Stay Hungry, Stay Foolish.' This speech became one of his most enduring personal legacies.",
    videoUrl: 'https://www.youtube.com/watch?v=UF8uR6Z6KLc',
  },
  {
    id: 61,
    year: 2006,
    title: 'Disney Acquires Pixar',
    description:
      "On January 24, 2006, Disney acquired Pixar for $7.4 billion, making Jobs Disney's largest individual shareholder and bringing him onto Disney's board of directors.",
    image: '/images/steve/disney-pixar-acquisition.jpg',
  },
  {
    id: 62,
    year: 2006,
    title: "'Mac vs PC' Campaign Launch",
    description:
      "Apple starts its famous 'Mac vs PC' campaign, a series of TV commercials featuring Justin Long as Mac and John Hodgman as PC. The campaign lasted for three years and marked popular culture.",
    videoUrl: 'https://www.youtube.com/watch?v=0eEG5LVXdKo',
  },
  {
    id: 63,
    year: 2007,
    title: "Apple Drops 'Computer' from Name",
    description:
      "On January 9, 2007, during the iPhone announcement, Jobs announced Apple Computer, Inc. would become Apple Inc., signaling the company's transition to a broader consumer electronics company.",
    videoUrl: 'https://www.youtube.com/watch?v=x3sg8b5iXO4',
  },
  {
    id: 64,
    year: 2007,
    title: 'iPhone Keynote Announcement',
    description:
      "On January 9, 2007, Jobs delivered his most iconic keynote, introducing the iPhone as 'An iPod, a phone, and an internet communicator,' revolutionizing the mobile industry forever.",
    videoUrl: 'https://www.youtube.com/watch?v=9hUIxyE2Ns8',
  },
  {
    id: 66,
    year: 2007,
    title: 'D5 Conference - Steve Jobs & Bill Gates Interview',
    description:
      'Jobs and Gates historic joint appearance discussing personal computing legacy and future—powerful retrospective and relationship moment.',
    videoUrl: 'https://www.youtube.com/watch?v=wvhW8cp15tk',
  },
  {
    id: 67,
    year: 2008,
    title: 'MacBook Air Unveiling',
    description:
      "On January 15, 2008, Jobs revealed the ultra-thin MacBook Air with the iconic 'envelope reveal,' highlighting Apple's commitment to design excellence and innovation in portable computing.",
    videoUrl: 'https://www.youtube.com/watch?v=OIV6peKMj9M',
  },
  {
    id: 68,
    year: 2010,
    title: 'iPad Announcement',
    description:
      'On January 27, 2010, Jobs introduced the iPad, creating and defining the tablet category that would revolutionize portable computing.',
    videoUrl: 'https://www.youtube.com/watch?v=zZtWlSDvb_k',
  },
  {
    id: 69,
    year: 2010,
    title: 'Antennagate Press Conference',
    description:
      "On July 16, 2010, Jobs held a press conference addressing iPhone 4 antenna issues, famously stating, 'We're not perfect.' This demonstrated his approach to public relations during product challenges.",
    videoUrl: 'https://www.youtube.com/watch?v=Q-UgUnMt6Ds',
  },
  {
    id: 70,
    year: 2011,
    title: 'Apple Park Campus Presentation',
    description:
      "On June 7, 2011, one of Jobs' last public appearances, presenting Apple's vision for the spaceship campus to Cupertino city officials.",
    videoUrl: 'https://www.youtube.com/watch?v=gtuz5OmOh_M',
  },
  {
    id: 71,
    year: 2011,
    title: "Jobs' Involvement in Creating Apple Park",
    description:
      "Visionary legacy; the spaceship campus symbolized Jobs' obsession with detail and design aesthetics.",
    image: '/images/steve/apple-park-vision.jpg',
  },
  {
    id: 72,
    year: 2011,
    title: 'Passing of Steve Jobs',
    description:
      "Steve Jobs passed away on October 5, 2011, leading to global tributes and Apple's official memoriam. His legacy as a visionary in technology and design continues to influence the industry.",
    image: '/images/steve/steve-jobs-memorial.jpg',
  },
  // Additional Notable Moments (will be sorted into correct chronological position)
  {
    id: 73,
    year: 1997,
    title: 'Jobs Hiring Jony Ive',
    description:
      "Partnership crucial to Apple's design legacy starting from 1997 onward when Ive became instrumental to Apple's design renaissance.",
    image: '/images/steve/jobs-ive-partnership.jpg',
  },
  {
    id: 74,
    year: 1998,
    title: 'The Apple Newton PDA Failure Termination',
    description:
      "Represents Apple's struggle before Jobs' return and his decision to terminate the product line immediately upon his return, reflecting his ruthless product focus.",
    image: '/images/steve/newton-failure.jpg',
  },
]

// Sort by year, then by id for same-year items
export const timelineData = [...rawTimelineData].sort((a, b) => {
  if (a.year !== b.year) return a.year - b.year
  return a.id - b.id
})
